export default __webpack_public_path__ + "static/media/amparo-arte-8.e09180ea.webp";